<template>
  <div>
    logout
  </div>
</template>


<script>
 import store from '@/store';
 export default {
   async beforeRouteEnter (to, from, next) {
     await store.dispatch('logout')
     next('login');
   }
 }
</script>
